import React, { useState } from 'react'
import {
  CAlert, CButton, CCard, CCardBody, CCol, CRow, CForm, CFormInput, CFormLabel,
} from '@coreui/react'
import { api, currentUser } from '../api/client'

/**
 * Mi Clave — réplica de cambiasuclave.cs (SiprinMax GX).
 * Campos exactos del GX (incluido el typo "Nueva Contraeña").
 */
const CambiarClavePage: React.FC = () => {
  const usuario = currentUser()
  const [claveActual, setClaveActual] = useState('')
  const [nuevaClave, setNuevaClave] = useState('')
  const [confirmacion, setConfirmacion] = useState('')
  const [error, setError] = useState('')
  const [exito, setExito] = useState('')
  const [cambiada, setCambiada] = useState(false)

  const enviar = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setExito('')

    const nueva = nuevaClave.trim()
    if (nueva !== confirmacion.trim()) {
      setError('The new password and confirmation do not match.')
      return
    }
    // [RGM] 2026-11-04 (decisión Rafael): sin mínimo — 1 carácter es válido.
    // [RGM] 2026-09-16: UsuarioClave es char(15) — máximo 15.
    if (nueva.length > 15) {
      setError('La nueva clave no puede tener más de 15 caracteres')
      return
    }

    try {
      const res = await api.post<{ message: string }>('/auth/cambiar-clave', {
        claveActual: claveActual.trim(),
        nuevaClave: nueva,
        confirmacion: nueva,
      })
      setExito(res.message)
      setCambiada(true)
      setClaveActual('')
      setNuevaClave('')
      setConfirmacion('')
    } catch (err: any) {
      setError(err.message)
    }
  }

  return (
    <>
      <CRow className="mb-4">
        <CCol>
          <h4>Mi Clave</h4>
        </CCol>
      </CRow>

      {error && <CAlert color="danger" dismissible onClose={() => setError('')}>{error}</CAlert>}
      {exito && <CAlert color="success" dismissible onClose={() => setExito('')}>{exito}</CAlert>}

      <CCard className="mb-4">
        <CCardBody>
          <CForm onSubmit={enviar}>
            <CRow className="g-3">
              <CCol md={6}>
                <CFormLabel>Nombre de Usuario</CFormLabel>
                <CFormInput value={usuario?.id ?? ''} readOnly />
              </CCol>
              <CCol md={6}></CCol>
              <CCol md={6}>
                <CFormLabel>Contraseña Actual</CFormLabel>
                <CFormInput
                  type="password"
                  value={claveActual}
                  disabled={cambiada}
                  onChange={(e) => setClaveActual(e.target.value)}
                />
              </CCol>
              <CCol md={6}></CCol>
              <CCol md={6}>
                <CFormLabel>Nueva Contraeña</CFormLabel>
                <CFormInput
                  type="password"
                  value={nuevaClave}
                  disabled={cambiada}
                  maxLength={15}
                  onChange={(e) => setNuevaClave(e.target.value)}
                />
                <small className="text-body-secondary">Máximo 15 caracteres</small>
              </CCol>
              <CCol md={6}>
                <CFormLabel>Confirme Contraseña</CFormLabel>
                <CFormInput
                  type="password"
                  value={confirmacion}
                  disabled={cambiada}
                  maxLength={15}
                  onChange={(e) => setConfirmacion(e.target.value)}
                />
              </CCol>
            </CRow>
            <div className="d-flex justify-content-end mt-3">
              <CButton color="primary" type="submit" disabled={cambiada}>
                Cambiar clave
              </CButton>
            </div>
          </CForm>
        </CCardBody>
      </CCard>
    </>
  )
}

export default CambiarClavePage
